export default __webpack_public_path__ + "static/media/board.8a0e035e.svg";